import { styled } from '@pata-app/themes';

export const FeaturesNavigationContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.core.sizing[3]}px;

  width: 100%;

  margin-top: ${({ theme }) => theme.core.sizing[5]}px;

  overflow-x: auto;

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    justify-content: center;
  }
`;

export const FeaturesNavigationItemContainer = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.core.sizing[1]}px;

  width: 150px;
  min-width: 150px;
  height: 100px;

  background: ${({ theme }) => theme.core.colors.greyscale.white};

  border-radius: ${({ theme }) => theme.core.border.element.radius}px;
  border: 0.5px solid ${({ theme }) => theme.core.colors.greyscale.black};

  cursor: pointer;

  span {
    font-weight: ${({ theme }) => theme.core.fontWeight.medium};
  }

  &:hover {
    color: ${({ theme }) => theme.core.colors.primary.green.medium};
    border: 1px solid ${({ theme }) => theme.core.colors.primary.green.medium};

    svg {
      fill: ${({ theme }) => theme.core.colors.primary.green.medium};
    }
  }
`;
